import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { SecuredLayout } from '../Layout/SecuredLayout';
import { useAuth } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { Role } from '../../@types/auth';
import Navbar from '../Layout/Navbar';
import SpeedLimitEditor from './SpeedLimitEditor';

export default function SpeedLimits() {
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        if (!(user?.hasRole(Role.FOVEZENYLO) || user?.hasRole(Role.ADMIN))) {
            navigate('/');
        }
    }, [user, navigate]);

    return (
        <SecuredLayout>
            <Grid container px={2}>
                <Grid container py={1} item xs={12} textAlign={'right'} sx={{ justifyContent: 'space-between' }}>
                    <Navbar />
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SpeedLimitEditor busType='large' label='Nagybusz' />
                    </Grid>
                    <Grid item xs={6}>
                        <SpeedLimitEditor busType='small' label='Kisbusz' />
                    </Grid>
                </Grid>
            </Grid>
        </SecuredLayout>
    );
}